import { faXTwitter } from '@fortawesome/free-brands-svg-icons'
import { faLockKeyhole } from '@fortawesome/pro-duotone-svg-icons'
import { Card, CardHeader, Stack } from '@mui/material'
import { memo } from 'react'

import { postXMessageUrl } from '../../util/earnVia.helpers'
import { NAVIGATION_BLANK_PARAMS } from '../../util/navigation.helpers'
import Button from '../shared/button/Button'
import FaIcon from 'src/components/shared/faIcon/FaIcon'

const RewardedPosts = ({ t, reqNotMet, onCheckReq, connected }) => {
  return (
    <Card sx={{ p: 3 }}>
      <CardHeader
        title={t('earn-via.rewarded-posts')}
        subheader={t('earn-via.rewarded-posts-desc')}
        sx={{ p: 0 }}
      />
      <Stack spacing={2} alignItems='flex-end' mt={2}>
        {reqNotMet ? (
          <Button
            startIcon={<FaIcon icon={faLockKeyhole} />}
            label={t('earn-via.check-requirements')}
            onClick={onCheckReq}
          />
        ) : (
          <Button
            startIcon={<FaIcon icon={faXTwitter} />}
            label={t('earn-via.write-x-post')}
            disabled={!connected}
            component='a'
            href={postXMessageUrl()}
            {...NAVIGATION_BLANK_PARAMS}
          />
        )}
      </Stack>
    </Card>
  )
}

export default memo(RewardedPosts)
